import { render } from "./ShoppingListSearchInputView.vue?vue&type=template&id=48e8088c&scoped=true&ts=true"
import script from "./ShoppingListSearchInputView.vue?vue&type=script&lang=ts"
export * from "./ShoppingListSearchInputView.vue?vue&type=script&lang=ts"

import "./ShoppingListSearchInputView.vue?vue&type=style&index=0&id=48e8088c&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e8088c"]])

export default __exports__